import React, { Children, Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Table } from "antd";
import { toJS, runInAction, action } from "mobx";
import TableText from "../../table/TableText";
import { calculation } from "@/method";

const totalIndex = [];

@inject("store")
@observer
class App extends Component {
  @action
  onChange = (name, value, i) => {
    let data = toJS(this.props.store.kpifollow.submarket);
    data[i][name] = value;
    this.props.store.kpifollow.submarket = data;
  };

  render() {
    const { data, loading, submarket } = this.props.store.kpifollow;
    const columns = [
      {
        title: "携程",
        align: "center",
        children: [
          {
            dataIndex: `name1`,
            key: `name1`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "text",
                name: `name1`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
          {
            dataIndex: `value1`,
            key: `value1`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `value1`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
      {
        title: "美团",
        align: "center",
        children: [
          {
            dataIndex: `name2`,
            key: `name2`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "text",
                name: `name2`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
          {
            dataIndex: `value2`,
            key: `value2`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `value2`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
      {
        title: "RFP协议单位",
        align: "center",
        children: [
          {
            dataIndex: `name3`,
            key: `name3`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "text",
                name: `name3`,
                onChange: this.onChange,
                totalIndex: [2],
              };
              if (index == 2)
                return {
                  props: {
                    colSpan: 2,
                  },
                  children: <TableText data={props} />,
                };
              return <TableText data={props} />;
            },
          },
          {
            dataIndex: `value3`,
            key: `value3`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `value3`,
                onChange: this.onChange,
                totalIndex: [2],
              };
              if (index == 2)
                return {
                  props: {
                    colSpan: 0,
                  },
                };
              return <TableText data={props} />;
            },
          },
        ],
      },
    ];

    return (
      <div className="" style={{ marginTop: 50 }}>
        <div>
          <Row className="secondary_title">商圈数据呈现</Row>
          <Table
            columns={columns}
            dataSource={toJS(submarket)}
            size="middle"
            bordered
            pagination={false}
            className="content"
            rowKey={"r.name"}
          />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/Table5.js